export const FETCH_ALL = 'tags/FETCH_ALL';
export const FETCH_ALL_SUCCESS = 'tags/FETCH_ALL_SUCCESS';
export const FETCH_ALL_ERROR = 'tags/FETCH_ALL_ERROR';

export const CREATE = 'tags/CREATE';
export const CREATE_SUCCESS = 'tags/CREATE_SUCCESS';
export const CREATE_ERROR = 'tags/CREATE_ERROR';

export const UPDATE = 'tags/UPDATE';
export const UPDATE_SUCCESS = 'tags/UPDATE_SUCCESS';
export const UPDATE_ERROR = 'tags/UPDATE_ERROR';

export const DELETE = 'tags/DELETE';
export const DELETE_SUCCESS = 'tags/DELETE_SUCCESS';
export const DELETE_ERROR = 'tags/DELETE_ERROR';

export const SET_ACTIVE_TAG_ID = 'tags/SET_ACTIVE_TAG_ID';
